// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import GET_AUTO_MESSAGE_WITHOUT_SENDS_QUERY from 'admin/components/AdminAutoMessages/queries/GetAutoMessageWithoutSends.gql';
import GET_AUTO_MESSAGES_FOR_ORG_QUERY from 'admin/components/AdminAutoMessages/queries/GetAutoMessagesForOrg.gql';
import SAVE_AUTO_MESSAGE_MUTATION from './queries/SaveAutoMessageMutation.gql';
import ADMIN_NEW_AUTO_MESSAGE_ORGS_QUERY from './queries/AdminNewAutoMessageOrgsQuery.gql';

import type { GetAutoMessageWithoutSends_autoMessaging_autoMessages_autoMessages } from 'admin/components/AdminAutoMessages/queries/__generated__/GetAutoMessageWithoutSends';
import type { AdminNewAutoMessageOrgs_organizations } from './queries/__generated__/AdminNewAutoMessageOrgs';

type Props = {
  children: (props: {
    autoMessage: ?GetAutoMessageWithoutSends_autoMessaging_autoMessages_autoMessages,
    loading: ?boolean,
    orgs: ?(AdminNewAutoMessageOrgs_organizations[]),
    save: (input: SaveAutoMessageInput) => Promise<*>,
  }) => React.Node,
  messageUuid: ?string,
  organizationUUID: string,

  // from gql
  autoMessage: ?GetAutoMessageWithoutSends_autoMessaging_autoMessages_autoMessages,
  orgs: ?(AdminNewAutoMessageOrgs_organizations[]),
  loadingMessage: boolean,
  loadingOrgs: boolean,
  mutate: ({
    variables: {
      input: SaveAutoMessageInput,
    },
    refetchQueries: *[],
  }) => Promise<*>,
};

class AdminNewAutoMessageContainer extends React.Component<Props, void> {
  render() {
    const {
      loadingMessage,
      autoMessage,
      children,
      mutate,
      orgs,
      loadingOrgs,
      organizationUUID,
    } = this.props;

    return children({
      loading: loadingMessage || loadingOrgs,
      autoMessage,
      orgs,
      save: input =>
        mutate({
          variables: { input },
          refetchQueries: [
            {
              query: GET_AUTO_MESSAGES_FOR_ORG_QUERY,
              variables: { organizationUUID },
            },
          ],
        }),
    });
  }
}

const withExistingMessage = graphql(GET_AUTO_MESSAGE_WITHOUT_SENDS_QUERY, {
  skip: ({ messageUuid }) => !messageUuid,
  options: ({ messageUuid }) => ({
    variables: { messageUuid },
  }),
  props: ({ data }) => ({
    loadingMessage: data.loading,
    autoMessage: idx(data, _ => _.autoMessaging.autoMessages.autoMessages[0]),
  }),
});

const withOrgs = graphql(ADMIN_NEW_AUTO_MESSAGE_ORGS_QUERY, {
  options: ({ organizationUUID }) => ({
    variables: { organizationUUID },
  }),
  props: ({ data }) => {
    const topLevelOrg = idx(data, _ => _.organizations[0]);
    const orgs = topLevelOrg ? [topLevelOrg, ...(topLevelOrg.childOrganizations || [])] : [];
    return {
      loadingOrgs: data.loading,
      orgs,
    };
  },
});

const withMutation = graphql(SAVE_AUTO_MESSAGE_MUTATION);

export { AdminNewAutoMessageContainer };

export default compose(
  withExistingMessage,
  withOrgs,
  withMutation
)(AdminNewAutoMessageContainer);
